module.exports = __webpack_public_path__ + "img/culture_icon1.279f466c.png";